var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.611 12.313a.77.77 0 0 1 1.311.794l-.072.119L19.08 27.84a.77.77 0 0 1-.98.223l-.119-.079-7.692-6.154a.77.77 0 0 1 .845-1.278l.116.077 7.067 5.653 10.294-13.97z","fill":"#63A615","fillRule":"evenodd"}));
}

IconCheck.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = IconCheck;

IconCheck.default = IconCheck;
